import {toast, type ExternalToast} from "sonner";

export const ADMIN_TOASTER_ID = "cc-admin";

const DEFAULTS: ExternalToast = {
  toasterId: ADMIN_TOASTER_ID,
  duration: 4500,
  dismissible: true,
  closeButton: true
};

function fire(
  kind: "success" | "error" | "info" | "warning",
  message: string,
  opts?: ExternalToast
) {
  const id = opts?.id ?? `admin-${kind}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
  const body = (
    <button
      type="button"
      className="admin-toast__hit"
      onClick={() => toast.dismiss(id)}
    >
      {message}
    </button>
  );
  return toast[kind](body, {...DEFAULTS, ...opts, id});
}

export const adminToast = {
  success: (message: string, opts?: ExternalToast) => fire("success", message, opts),
  error: (message: string, opts?: ExternalToast) => fire("error", message, opts),
  info: (message: string, opts?: ExternalToast) => fire("info", message, opts),
  warning: (message: string, opts?: ExternalToast) => fire("warning", message, opts),
  dismiss: (id?: string | number) => toast.dismiss(id)
};
